import { render } from "./life-care.vue?vue&type=template&id=f5ab41ae&scoped=true"
import script from "./life-care.vue?vue&type=script&lang=js"
export * from "./life-care.vue?vue&type=script&lang=js"

import "./life-care.vue?vue&type=style&index=0&id=f5ab41ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ab41ae"]])

export default __exports__